import { render, staticRenderFns } from "./HelpdeskTicketThread.vue?vue&type=template&id=03215477&scoped=true"
import script from "./HelpdeskTicketThread.vue?vue&type=script&lang=js"
export * from "./HelpdeskTicketThread.vue?vue&type=script&lang=js"
import style0 from "./HelpdeskTicketThread.vue?vue&type=style&index=0&id=03215477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03215477",
  null
  
)

export default component.exports